class AmenityMap {
	/**
	 * Initialize Amenity map
	 * @param  {[JSON]} {primary_exists: :bool, icon: url:string}    
	 * @param  {[JSON]} {map_options: {map options object (see google)}, map_styles: {map styles object (see google)}}
	 * @param  {[JSON]} {infobox_styles: {infobox styles object}}
	 * @param  {Function} {pass in callback function to call after code runs}
	 * @return {[type]}                    [description]
	 */
	constructor(amenity_map_settings={}, map_settings={}, infobox_settings={}, callback=null) {
		// highest level
		this.settings = {};
		this.google_map = null;

		this.infobox = null;
		this.is_infobox_open = false;

		this.map_markers = [];
		this.localized_variables = AM_LOCALIZED;

		// blocks
		this.categories = $('.am-categories');
		this.active_marker = {};
		this.previous_marker = {};

		// dump localized variables into constructor settings
		amenity_map_settings = {'primary_location': JSON.parse(this.localized_variables['primary_location']), 'active_icon': this.localized_variables['active_icon']};
		map_settings = JSON.parse(this.localized_variables.map_styles);

		let parsed_infobox_settings = JSON.parse(this.localized_variables['infobox_settings']);
		infobox_settings = {'style': parsed_infobox_settings.infobox_style, 'address': parsed_infobox_settings.address, 'phone': parsed_infobox_settings.phone, 'website': parsed_infobox_settings.website};
		
		// amenity related variables
		this.category = 'all';
		this.amenities = [];
		this.markers = [];

		// construct default options 
		this.defaults(amenity_map_settings, map_settings, infobox_settings, callback);

		// attach click handler
		this.handle_category_click();

		// populate amenities
		this.filter_categories();
	}

	/**
	 * Get category from user click.  
	 */
	handle_category_click() {
		let _this = this;
		_this.categories.find('a').on('click', function(e){
			e.preventDefault();

			let same_link = false;

			if (_this.category == $(this).data('term-slug')) {
				same_link = true;
			}
			_this.category = ($(this).parent().hasClass('am-categories--active')) ? _this.category : $(this).data('term-slug');

			// add and remove active classes
			
			if (!same_link) {
				_this.categories.find('li').removeClass('am-categories--active');
				$(this).parent().addClass('am-categories--active');
				_this.filter_categories();
			}

		});
	}

	/**
	 * Populate amenities with amenities that fit user selected category. 
	 */
	filter_categories() {
		this.amenities = []; // reset value each time
		let amenities = this.localized_variables['data']['posts'];

		// if category is all show all amenities, otherwise filter them. 
		this.amenities = (this.category == 'all' ? amenities : amenities.filter((amenity) => amenity.amenity_category[0] === this.category));

		// build amenity map
		this.build_amenity_map();
	}

	/**
	 * Build the amenity map by instantiating google map, adding markers to map, and initializing infobox
	 * 
	 */
	build_amenity_map() {
		const _this = this;
		let bounds = new google.maps.LatLngBounds();

		this.map_markers = [];

		// keep track of primary location id
		let primary_id = typeof this.settings.amenity_map_settings.primary_location.primary_location !== 'undefined' ? this.settings.amenity_map_settings.primary_location.primary_location : -1;

		// instantiate the map
		this.google_map = new google.maps.Map(document.getElementById("am-map"), this.settings.google_map_settings);
		
		if (this.infobox === null) {
			this.infobox = new InfoBox({
				content: $("#infobox"),
				pixelOffset: new google.maps.Size(-62, 27),
				zIndex: null,
				boxStyle: this.settings.infobox_settings,
				closeBoxMargin: "-4px -7px -5px 5px",
				closeBoxURL: this.localized_variables["theme_url"] + "/assets/img/close_lightbox.png"
			});
		}
		
		// add markers to map
		for (let amenity of this.amenities) {
			this.add_marker(amenity, bounds);
		}

		// add primary location
		this.add_marker(null, bounds, true);

		// set up primary location
		this.google_map.fitBounds(bounds);

	}

	/**
	 * Add amenity marker to map
	 * @param {[type]} amenity [description]
	 * @param {[type]} bounds  [description]
	 */
	add_marker(amenity, bounds, is_primary = false) {
		let _this = this;
		let primary_location = this.settings.amenity_map_settings.primary_location;
		
		let amenity_lat_lng = ( is_primary ? new google.maps.LatLng(primary_location.primary_latitude, primary_location.primary_longitude) : new google.maps.LatLng(amenity.amenity_latitude, amenity.amenity_longitude) );
		bounds.extend(amenity_lat_lng);

		let icon = is_primary ? {url: (primary_location.primary_icon === null ? 'http://www.loghillrun.net/images/icon2.png' : primary_location.primary_icon), scaledSize: new google.maps.Size(30, 30)} : {url: (amenity.term_icon === null ? 'http://www.loghillrun.net/images/icon2.png' : amenity.term_icon), scaledSize: new google.maps.Size(30, 30)};

		let marker = new google.maps.Marker({
			position: amenity_lat_lng,
			map: this.google_map,
			zoom: 11,
			title: "Primary Location",
			icon: icon
		});

		marker.setIcon(icon);

		// push marker to marker array
		this.map_markers.push(marker);

		if (!is_primary) {
			google.maps.event.addListener(marker, 'click', function (marker) {
				return function () {
					// create active marker object and push it to active marker queue
					if (_this.is_infobox_open) {
						_this.deactivize_icon(_this.previous_marker);
						_this.infobox.close();	
					}
					_this.active_marker.marker = marker;
					_this.active_marker.icon = icon;

					_this.is_infobox_open = true;

					_this.activize_icon(marker);
					_this.get_place(marker, amenity);

					_this.previous_marker = marker; // keep track of previous marker
				};
			}(marker));

			google.maps.event.addListener(_this.infobox, 'closeclick', function (marker) {
				return function () {
					_this.is_infobox_open = false;
					_this.deactivize_icon(_this.previous_marker);
				};
			}(marker));
		}
	}

	/**
	 * Get the place id using google services
	 * @param  {[type]} marker  [description]
	 * @param  {[type]} amenity [description]
	 */
	get_place(marker, amenity) {
		const _this = this;
		const place_id = amenity.place_id;
		const service = new google.maps.places.PlacesService(this.google_map);
		let html = "";

		service.getDetails({
			placeId: place_id
		}, (place, status) => {
			if (status === google.maps.places.PlacesServiceStatus.OK) {
				let extended_amenity = $.extend({}, amenity, place);
				let lat_lng = new google.maps.LatLng(amenity.amenity_latitude, amenity.amenity_longitude);

				html = _this.write_markup(extended_amenity);
				_this.infobox.setContent(html);
				_this.infobox.open(_this.google_map, marker);
				_this.google_map.panTo(lat_lng);
			}
		});
	}

	/**
	 * Make icon active state
	 * @param  {[type]} marker [description]
	 * @return {[type]}        [description]
	 */
	activize_icon(marker) {
		let icon = {
			url: this.settings.amenity_map_settings.active_icon,
			scaledSize: new google.maps.Size(30, 30)
		}
		marker.setIcon(icon);
	}

	deactivize_icon(marker) {
		let icon = {
			url: this.active_marker.icon.url,
			scaledSize: new google.maps.Size(30, 30)
		}
		marker.setIcon(icon);
	}

	/**
	 * Write up HTML given the place object
	 * @param  {[type]} place [description]
	 * @return {[type]}       [description]
	 */
	write_markup(place) {
		var html = '';

		var address = typeof place.adr_address !== "undefined" ? place.adr_address : '';
		var phone = typeof place.formatted_phone_number !== "undefined" ? place.formatted_phone_number : '';
		var website = typeof place.website !== "undefined" ? place.website : '';
		var opening_hours = typeof place.opening_hours !== "undefined" ? place.opening_hours.weekday_text : '';
		var hours_string = '';
		for (var i = 0; i < opening_hours.length; i++) hours_string += '<li>' + opening_hours[i] + '</li>';

		html += `<div class="infobox__inner">`;
		html +=	`<h3 class="infobox__title">${place.name}</h3>`;
		html +=	this.settings.info_display.address === "1" ? `<div class="infobox__address">${address}</div>` : '';
		html +=	this.settings.info_display.phone === "1" ? `<div class="infobox__phone"><a href="tel:${phone}">${phone}</a></div>` : '';
		html += this.settings.info_display.website === "1" ? `<div class="infobox__website"><a href="${website}" target="_blank">${website}</a></div>` : '';
		html += `<p class="infobox__link"><a class="google-map-link" href="${place.url}" target="_blank">View in Google Maps</a></p>`;
		html += '</div>';

		return html;
	}



	/*
	* Define our default settings, extend them with user defined settings, append them all to settings. 
	 */
	defaults(user_amenity_map_settings, user_map_settings, user_infobox_settings, user_callback) {
		// amenity map settings
		let default_amenity_map_settings = {'primary_location': null, 'icon': '', 'center': {'latitude': 43.6601, 'longitude': -79.4347}};
		let amenity_map_settings = $.extend({}, default_amenity_map_settings, user_amenity_map_settings);

		// google map settings
		let default_map_styles = [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#a0d6d1"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#dedede"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#dedede"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f1f1f1"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}];
		let map_styles = user_map_settings.map_styles ? JSON.parse(user_map_settings.map_styles) : default_map_styles;


		let default_map_settings = {
			styles: map_styles,
			mapTypeId: 'roadmap',
			scrollwheel: false,
			center: {lat: amenity_map_settings.center.latitude, lng: amenity_map_settings.center.longitude},
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			scrollwheel: false,
			zoom: 10
		};
		let google_map_settings = $.extend({}, default_map_settings, user_map_settings.map_options );
		
		// infobox settings
		let default_infobox_settings = {
			opacity: 1,
			width: "auto",
			backgroundColor: "rgba(0, 0, 0, 0.9)",
			color: "#fff",
			padding: "24px 31px",
			borderRadius: "12px",
			fontSize: '12px'
		}
		let infobox_settings = $.extend({}, default_infobox_settings, user_infobox_settings.style);

		// now let's remove style. Note that Objects are immutable. So it's necessary that we cloned style into
		// infobox_settings before we deleted it. 
		delete user_infobox_settings.style;

		let callback = user_callback;

		this.settings = {
			'amenity_map_settings': amenity_map_settings, 
			'google_map_settings': google_map_settings, 
			'infobox_settings': infobox_settings, 
			'info_display': user_infobox_settings,
			'callback': callback
		};
	}

	resize() {
		this.viewport_width = $(window).width();
	}
}

module.exports = AmenityMap;